// Modo de orden de los tableros de una organización: el del catálogo o uno personalizado.
export const ORDER_MODE = {
  catalog: 'catalog',
  custom: 'custom'
}

// Estado pendiente de una fila de "Habilitados" mientras se edita.
export const DASHBOARD_PENDING = {
  add: 'add',
  remove: 'remove'
}

// Valores del filtro "Acceso" de la matriz de usuarios; son los que entiende el backend.
export const USER_ACCESS = { with: 'with', without: 'without', all: 'all' }

// Celda de la matriz que se está guardando cuando es la casilla "Todos" de la fila (si no, es el id del tablero).
export const SAVING_ALL = 'all'

// Contenedor de la página al que el panel de usuarios manda su barra de selección.
export const BULK_BAR_TARGET_ID = 'analytics-users-bulk-bar'

// Máximo de usuarios seleccionados a la vez: el que acepta el endpoint en una sola operación.
export const SELECTION_LIMIT = 1000

// Texto del confirm de salir con cambios sin guardar en el formulario de tablero y en el modo reordenar.
export const DISCARD_MESSAGE_UNSAVED = 'analytics.discard_message_unsaved'
